import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_OFFICES,
  CREATE_OFFICES,
  DELETE_OFFICES,
  UPDATE_OFFICES,
  GET_OFFICES_BY_ID,
} from './actionType';

import { OfficesApiResponseSuccess, OfficesApiResponseError } from './action';

import {
  getOffices as OficesGet,
  createOffices as OficesCreate,
  updateOffices as OficesUpdate,
  deleteOffices as OficesDelete,
  getOfficesById,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getOffices() {
  try {
    const response = yield call(OficesGet);
    yield put(OfficesApiResponseSuccess(GET_OFFICES, response));
  } catch (error) {
    yield put(OfficesApiResponseError(GET_OFFICES, error));
  }
}

function* officesById({ payload }) {
  const { id } = payload;

  try {
    const response = yield call(getOfficesById, id);
    yield put(OfficesApiResponseSuccess(GET_OFFICES_BY_ID, response));
  } catch (error) {
    yield put(OfficesApiResponseError(GET_OFFICES_BY_ID, error));
  }
}

function* createOffices(data) {
  try {
    const response = yield call(OficesCreate, data.payload.data);
    yield put(OfficesApiResponseSuccess(CREATE_OFFICES, response));
    notifySuccess('Escritório criado com sucesso!');
  } catch (error) {
    yield put(OfficesApiResponseError(CREATE_OFFICES, error));
    notifyError('Erro ao criar escritório!');
  }
}

function* updateOffices(data) {
  try {
    const response = yield call(OficesUpdate, {
      id: data.payload.id,
      data: data.payload.data,
    });
    yield put(OfficesApiResponseSuccess(UPDATE_OFFICES, response));
    notifySuccess('Escritório atualizado com sucesso!');
  } catch (error) {
    yield put(OfficesApiResponseError(UPDATE_OFFICES, error));
    notifyError('Erro ao atualizar escritório!');
  }
}

function* deleteOffices({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(OficesDelete, id);
    yield put(OfficesApiResponseSuccess(DELETE_OFFICES, response));
    notifySuccess('Escritório deletado com sucesso!');
  } catch (error) {
    yield put(OfficesApiResponseError(DELETE_OFFICES, error));
    notifyError('Erro ao deletar escritório!');
  }
}

export function* watchGetOffices() {
  yield takeEvery(GET_OFFICES, getOffices);
}

export function* watchGetOfficestById() {
  yield takeEvery(GET_OFFICES_BY_ID, officesById);
}

export function* watchCreateOffices() {
  yield takeEvery(CREATE_OFFICES, createOffices);
}

export function* watchUpdateOffices() {
  yield takeEvery(UPDATE_OFFICES, updateOffices);
}

export function* watchDeleteOffices() {
  yield takeEvery(DELETE_OFFICES, deleteOffices);
}

function* OfficesSaga() {
  yield all([fork(watchGetOffices)]);
  yield all([fork(watchCreateOffices)]);
  yield all([fork(watchUpdateOffices)]);
  yield all([fork(watchDeleteOffices)]);
  yield all([fork(watchGetOfficestById)]);
}

export default OfficesSaga;
